<template>
    <div
        class="fixed inset-0 bg-gradient-to-br from-blue-500 to-purple-600 dark:from-blue-600 dark:to-purple-700 flex items-center justify-center z-[9999]">
        <div class="text-center text-white dark:text-slate-100 max-w-xs w-full p-8 sm:p-4">
            <div class="mb-8">
                <img src="/pwa-192x192.png" alt="Oxly"
                    class="w-20 h-20 sm:w-16 sm:h-16 rounded-full shadow-lg shadow-black/20 dark:shadow-black/40 mx-auto animate-pulse-scale" />
            </div>
            <div class="my-8 flex justify-center">
                <div
                    class="w-10 h-10 border-4 border-white/20 dark:border-slate-100/20 border-t-white dark:border-t-slate-100 rounded-full animate-spin">
                </div>
            </div>
            <div class="space-y-2">
                <h2 class="text-2xl sm:text-xl font-semibold text-white dark:text-slate-100">{{ $t("appName") }}</h2>
                <p class="text-base sm:text-sm text-white/90 dark:text-slate-100/90">{{ $t('loading.message') }}</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
@keyframes pulse-scale {

    0%,
    100% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.05);
        opacity: 0.8;
    }
}

.animate-pulse-scale {
    animation: pulse-scale 2s infinite;
}
</style>